'use client';
import Header from '@/app/_components/layouts/headerV2';
import Listing from '@/app/_components/widgets/listing';
import { Suspense, useEffect, useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import apolloClient from '@/utils/apolloClient';

const CercaPage = () => {
  const [isLoadingData, setIsLoading] = useState(true);
  const [isFakeLoading, setFakeLoading] = useState(true);

  const timeToWait = 1000;

  // Show loading state for at least [timeToWait] ms
  useEffect(() => {
    setTimeout(() => {
      setFakeLoading(false);
    }, timeToWait);
  }, []);

  const isLoading = isLoadingData || isFakeLoading;

  return (
    <>
      <Header shouldShowTantoSvago type={isLoading ? 'only-logo' : 'full'} keepQueryParams scrollSearch />
      <ApolloProvider client={apolloClient}>
        <Suspense>
          <Listing loadingState={isLoading} setLoadingState={setIsLoading} showSearchSection />
        </Suspense>
      </ApolloProvider>
    </>
  );
};

export default CercaPage;
